export const DASHBOARD = 'dashboard'
export const DASHBOARD_ITEMS = 'dashboardItems'
export const DIMENSION_OPTIONS = 'dimension_options'
export const DATE_RANGE = 'date_range'
export const DIMENSION_STATE = 'dimension_state'
export const SELECTED_TAB = 'selected_tab'